import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";

import { BG_JOB_STATUS, storeConstants } from "../../../../constants";
import {
  calculateBarWidth,
  formatedDateTime,
  getResetInventoryColumns,
} from "../../../../shared/utility";
import CustomBodyModal from "../../../../shared/components/modal/CustomBodyModal";
import { ProgressBar, DataTableComponent } from "../../../../shared/components";

const ResetStatusModals = ({
  currentStore,
  showViewStatusModal,
  toggleViewStatusModal,
  getStoreMiscData,
  storeMiscData,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [columns, setColumns] = useState([]);
  let numOfRenders = useRef(0);
  const [gridState, setGridState] = useState({
    pageSize: 5,
    pageIndex: 0,
    sortBy: [],
  });

  useEffect(() => {
    if (showViewStatusModal) {
      getStoreMiscData(
        currentStore?.id,
        storeConstants.BG_JOB_RESET_INVENTORY_WITH_SHOPIFY
      );
    }
  }, [currentStore?.id, getStoreMiscData, showViewStatusModal]);

  const handleViewStatus = (status) => {
    setSelectedStatus(status);
  };

  const handleCloseDetailModal = () => {
    setSelectedStatus(null);
  };

  useEffect(() => {
    setColumns(
      getResetInventoryColumns({
        handleViewStatus: handleViewStatus,
      })
    );
  }, []);

  const selectedStoreMiscData = selectedStatus?.miscData;

  return (
    <>
      <CustomBodyModal
        title="Reset Shopify Status"
        show={showViewStatusModal}
        onHide={toggleViewStatusModal}
        size="lg"
      >
        <Row className="m-0 p-0 w-100">
          <DataTableComponent
            resizableColumns={false}
            className="editable-table"
            columns={columns}
            data={storeMiscData}
            key={numOfRenders.current}
            total={storeMiscData?.length || 0}
            gridState={gridState}
            setGridState={setGridState}
          />
        </Row>
      </CustomBodyModal>

      {selectedStatus && (
        <CustomBodyModal
          title="Reset Shopify Details"
          show={!!selectedStatus}
          onHide={handleCloseDetailModal}
          size="md"
        >
          <Row>
            <Col>
              <p className="my-1 fw-bold">Progress</p>
              <ProgressBar
                min={0}
                max={100}
                current={selectedStoreMiscData?.progressPercentage || 0}
                percentage={calculateBarWidth(
                  100,
                  selectedStoreMiscData?.progressPercentage || 0
                )}
                label={`${selectedStoreMiscData?.progressPercentage || 0}%`}
                barWrapper={true}
              />

              <div className="d-flex flex-column my-4 gap-2">
                <p>
                  <span className="fw-bold">Status:</span>{" "}
                  {selectedStoreMiscData?.status || "N/A"}
                </p>
                <p>
                  <span className="fw-bold">Started at:</span>{" "}
                  {selectedStoreMiscData?.startedAt
                    ? formatedDateTime(selectedStoreMiscData.startedAt)
                    : "N/A"}
                </p>
                {selectedStoreMiscData?.completedAt && (
                  <p>
                    <span className="fw-bold">Completed at:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.completedAt)}
                  </p>
                )}

                {selectedStoreMiscData?.resumeTime &&
                  selectedStoreMiscData?.status === BG_JOB_STATUS.PAUSED && (
                    <p>
                      <span className="fw-bold">Resumed at:</span>{" "}
                      {formatedDateTime(selectedStoreMiscData.resumeTime)}
                    </p>
                  )}

                <p>
                  <span className="fw-bold">Total Inventory Count:</span>{" "}
                  {selectedStoreMiscData?.totalInventoryCount ?? "N/A"}
                </p>
              </div>
            </Col>
          </Row>
        </CustomBodyModal>
      )}
    </>
  );
};

export default ResetStatusModals;
